import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import BlogPostsService from "src/_services/BlogPostsService";

export const getBlogPosts = createAsyncThunk(
    'blogPost/getBlogPosts',
    async ({ page, limit, searchKey }) => {
        const response = await BlogPostsService.getBlogPosts(page, limit, searchKey);
        return response.data.body;
    }
);
export const getBlogPostById = createAsyncThunk(
    'blogPost/getBlogPostById',
    async (id) => {
        const response = await BlogPostsService.getBlogPostById(id);
        return response.data.body;
    }
);
export const createBlogPost = createAsyncThunk(
    'blogPost/createBlogPost',
    async (payload) => {
        const response = await BlogPostsService.createBlogPost(payload);
        return response.data.body;
    }
);
export const updateBlogPost = createAsyncThunk(
    'blogPost/updateBlogPost',
    async ({id, payload}) => {
        const response = await BlogPostsService.updateBlogPost(id, payload);
        return response.data.body;
    }
);
export const deleteBlogPost = createAsyncThunk(
    'blogPost/deleteBlogPost',
    async (id) => {
        await BlogPostsService.deleteBlogPost(id);
        return id;
    }
);

const slice = createSlice({
    name: "blogPost",
    initialState: {
        list: [],
        listLoading: false,
        actionLoading: false,
        errorMessage: null,
        isSuccess: false,
        tableOptions: {
            rowCount: 20,
            page: 1,
            pageSize: 20,
        },
    },
    reducers: {
        updateLoading: (state, action) => {
            state.listLoading = action.payload
        },
        clearBlogPosts: (state) => {
            state.list = []
            state.errorMessage = null
            state.isSuccess = false
            state.tableOptions = {
                rowCount: 20,
                page: 1,
                pageSize: 20
            }
        },
        updateTableOptions: (state, { payload }) => {
            state.tableOptions = {
                ...state.tableOptions,
                ...payload,
            }
        },
    },
    extraReducers: {
        //=================get blogPosts ================
        [getBlogPosts.pending]: (state) => {
            state.listLoading = true
        },
        [getBlogPosts.fulfilled]: (state, { payload }) => {
            state.list = [...state.list, ...payload.docs]
            state.tableOptions = {
                ...state.tableOptions,
                rowCount: payload.totalDocs,
                page: payload.page,
            }

            state.listLoading = false
        },
        [getBlogPosts.rejected]: (state, action) => {
            state.listLoading = false
            state.errorMessage = action.error?.message ? action.error.message : 'Something went wrong please try again'
        },
        //=================get blogPost by Id ================
        [getBlogPostById.pending]: (state) => {
            state.errorMessage = null
            // state.actionLoading = true
        },
        [getBlogPostById.fulfilled]: (state, { payload }) => {
            // state.actionLoading = false
        },
        [getBlogPostById.rejected]: (state, action) => {
            // state.actionLoading = false
            state.errorMessage = action.error?.message ? action.error.message : 'Something went wrong please try again'
        },
        //=================create blogPost================
        [createBlogPost.pending]: (state) => {
            state.errorMessage = null
            state.actionLoading = true
        },
        [createBlogPost.fulfilled]: (state, { payload }) => {
            state.actionLoading = false
        },
        [createBlogPost.rejected]: (state, action) => {
            state.actionLoading = false
            state.errorMessage = action.error?.message ? action.error.message : 'Something went wrong please try again'
        },
        //=================update blogPost================
        [updateBlogPost.pending]: (state) => {
            state.errorMessage = null
            state.isSuccess = null
            state.actionLoading = true
        },
        [updateBlogPost.fulfilled]: (state, { payload }) => {
            state.actionLoading = false
            state.isSuccess = true
        },
        [updateBlogPost.rejected]: (state, action) => {
            state.actionLoading = false
            state.errorMessage = action.error?.message ? action.error.message : 'Something went wrong please try again'
        },
        //=================delete blogPost================
        [deleteBlogPost.pending]: (state) => {
            state.errorMessage = null
            state.isSuccess = null
            state.actionLoading = true
        },
        [deleteBlogPost.fulfilled]: (state, { payload }) => {
            state.actionLoading = false
        },
        [deleteBlogPost.rejected]: (state, action) => {
            state.actionLoading = false
            state.errorMessage = action.error?.message ? action.error.message : 'Something went wrong please try again'
        },
    },
});


export const {
    updateLoading,
    clearBlogPosts,
    updateTableOptions,
} = slice.actions;



export default slice.reducer;
